import { forwardRef, type ReactNode, type Ref, type HTMLAttributes } from 'react';

/** Visually hide content while keeping it readable for assistive tech. */
export const VisuallyHidden = forwardRef(function VisuallyHidden(
  { children, ...rest }: HTMLAttributes<HTMLSpanElement> & { children?: ReactNode },
  ref: Ref<HTMLSpanElement>
): ReactNode {
  return <span ref={ref} className="rr-sr-only" {...rest}>{children}</span>;
});
